var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-3", attrs: { role: "main", id: "instructions" } },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("PurposeChange.Title")))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("PurposeChange.Description")))]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(_vm._s(_vm.$t("PurposeChange.Arguments")))
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("PurposeChange.Arguments_Instructions")))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }